import {betterMod} from "../../shared/ts/helpers/better-mod";
import {onDomReady} from "../../shared/ts/helpers/on-dom-ready";

function fadeOut(el, duration, callback) {
  el.style.transition = `opacity ${duration}ms`
  el.style.opacity = '0'
  setTimeout(() => {
    el.style.display = 'none'
    el.hidden = true
    el.style.opacity = ''
    el.style.transition = ''
    if (callback) callback()
  }, duration)
}

function fadeIn(el, duration) {
  el.hidden = false
  el.style.display = 'block'
  el.style.opacity = '0'
  // double rAF ensures the browser commits display:block before starting the transition
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.style.transition = `opacity ${duration}ms`
      el.style.opacity = '1'
      setTimeout(() => {
        el.style.transition = ''
        el.style.opacity = ''
      }, duration)
    })
  })
}

function switchActiveContent(newCurrentLink, contentBox, pagination, currentIndex, newIndex) {
  const previousLink = pagination.querySelector('.content-clicker__link--active')
  if (previousLink) {
    previousLink.classList.remove('content-clicker__link--active')
    previousLink.setAttribute('aria-selected', 'false')
    previousLink.setAttribute('tabindex', '-1')
  }
  newCurrentLink.classList.add('content-clicker__link--active')
  newCurrentLink.setAttribute('aria-selected', 'true')
  newCurrentLink.setAttribute('tabindex', '0')

  const teasers = contentBox.querySelectorAll('.content-clicker__teaser')
  fadeOut(teasers[currentIndex], 50, function () {
    fadeIn(teasers[newIndex], 50)
  })

  return newIndex
}


function init() {
  document.querySelectorAll('.card--link').forEach(function (card) {
    const firstLink = card.querySelector('.link')
    if (firstLink) {
      card.addEventListener('click', function () {
        if (firstLink.getAttribute('target') == 'blank')
          window.open(firstLink.getAttribute('href'))
        else
          window.location.href = firstLink.getAttribute('href')
      })
    }
  })

  document.querySelectorAll('.content-clicker').forEach(function (el) {
    let currentIndex = 0
    const pagination = el.querySelector('.content-clicker__pagination')
    const contentBox = el.querySelector('.content-clicker__content')
    const contentBoxNumber = el.querySelectorAll('.content-clicker__teaser').length
    const links = Array.from(el.querySelectorAll('.content-clicker__link'))

    function activate(newIndex, moveFocus) {
      if (currentIndex !== newIndex) {
        currentIndex = switchActiveContent(links[newIndex], contentBox, pagination, currentIndex, newIndex)
      }
      if (moveFocus) {
        links[newIndex].focus()
      }
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault()
        activate(links.indexOf(link), false)
      })

      // Roving tabindex: only the selected tab is tabbable, so the arrow keys
      // have to move between the tabs, selecting as they go (ARIA tabs pattern).
      link.addEventListener('keydown', function (e) {
        const index = links.indexOf(link)
        let newIndex

        switch (e.key) {
          case 'Enter':
          case ' ':
            newIndex = index
            break
          case 'ArrowUp':
          case 'ArrowLeft':
            newIndex = betterMod(index - 1, links.length)
            break
          case 'ArrowDown':
          case 'ArrowRight':
            newIndex = betterMod(index + 1, links.length)
            break
          case 'Home':
            newIndex = 0
            break
          case 'End':
            newIndex = links.length - 1
            break
          default:
            return
        }

        e.preventDefault()
        activate(newIndex, true)
      })
    })

    el.querySelectorAll('.content-clicker__toggle').forEach(function (toggle) {
      function handleToggle(e) {
        if (e.type !== 'click' && e.key !== 'Enter' && e.key !== ' ') return
        e.preventDefault()

        const newIndex = toggle.classList.contains('content-clicker__toggle--down')
          ? betterMod(currentIndex + 1, contentBoxNumber)
          : betterMod(currentIndex - 1, contentBoxNumber)

        if (currentIndex !== newIndex) {
          currentIndex = switchActiveContent(links[newIndex], contentBox, pagination, currentIndex, newIndex)
        }
      }

      toggle.addEventListener('click', handleToggle)
      toggle.addEventListener('keydown', handleToggle)
    })
  })
}

onDomReady(init)
